/**
 * Serialize team identifier for API query params (e.g. team_id).
 * Sends string values the backend can resolve (numeric id or team name).
 */
export function teamIdQueryParam(teamId) {
  if (teamId == null || teamId === '') return null;
  if (typeof teamId === 'object' && teamId !== null) {
    const v = teamId.id ?? teamId._id;
    if (v == null || v === '') return null;
    return String(v).trim();
  }
  return String(teamId).trim();
}
